<template lang="pug">

  MDashboardWidget( title="(Superuser Only) Moonpull Report Generator" )

    div( class="form-group row" )
      div( class="col-sm-10" )
        label Batch ID(s)
        input( type="text" placeholder="Comma-separated Batch IDs" class="form-control" v-model="batchIds" )

    div( class="form-group row" ) 
      div( class="col-sm-10" )
        label Date range
        p( v-if="batchIds.length > 0" class="text-danger" ) Dates ignored when providing specific Batch ID(s)
        div( v-else )
          input( type="date" placeholder="End date" class="form-control" v-model="startDate" )
          input( type="date" placeholder="Start date" class="form-control" v-model="endDate" )

    div( class="form-group row" )
      div( class="col-sm-10" )
        label Advertiser ALP(s)
        input( type="text" placeholder="Comma-separated Advertiser ALP(s)" class="form-control" v-model="alps" )
    
    div( class="form-group row" )
      div( class="col-sm-10" )
        label Advertiser Name(s)
        input( type="text" placeholder="Comma-separated Advertiser name(s)" class="form-control" v-model="advertiserNames" )

    div( class="form-group row" )
      div( class="col-sm-10" )
        label Status
        select( class="form-control" v-model="status" )
          option( v-bind:value="null" ) All
          option( value="resolved" ) Resolved
          option( value="outstanding" ) Outstanding
    
    div( class="form-group row" )
      div( class="col-sm-10" )
        label Assignee(s)
        MUserSelector( v-on:input-full-object="onUserInput" label="Select one or more users:" )
        p( v-if="users.length > 0" )
          strong Selected:&nbsp;
          | {{ users.map(u => u.name).join(', ') }}
          br
          a( class="text-danger" href="#" v-on:click.prevent="users = []" ) Reset

          
    div( class="form-group row" )
      div( class="col-sm-10" )
        label Company
        MCompanySelector( v-on:input="onCompanyInput" label="Select Company:" )
    
    div( class="form-group row" )
      div( class="col-sm-10" )
        label Network
        MNetworkSelector( v-on:input="onNetworkInput" label="Select Network:" v-bind:disabled="! companyId" )

    div( class="form-group row" )
      div( class="col-sm-10" )
        label Audit Result
        br
        label
          input( class="mx-2" type="checkbox" v-on:click="results = []" v-bind:checked="results.length === 0" )
          | All
        label
          input( class="mx-2" type="checkbox" id="healthy" value="healthy" v-model="results" )
          | Healthy
        label
          input( class="mx-2" type="checkbox" id="critical" value="critical" v-model="results" )
          | Critical
        label
          input( class="mx-2" type="checkbox" id="warning" value="warning" v-model="results" )
          | Warnings
        label
          input( class="mx-2" type="checkbox" id="manual" value="manual" v-model="results" )
          | Manual Review
        label
          input( class="mx-2" type="checkbox" id="failed" value="failed" v-model="results" )
          | Failed

    div( class="form-group row" )
      div(class="col-sm-12 mt-3")
        button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="loading" v-on:click="generateCSV('client-standard')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          | Client Standard Report
        button( v-if="$moonpull.currentUserIsSuperAdmin()" class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="loading" v-on:click="generateCSV('debug')" )
          i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
          MMoonpullIcon
          | &nbsp;Debug Report
          
        p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}

</template>


<style lang="scss" scoped>
</style>

<script>
import gql from 'graphql-tag'
import Vue from 'vue'
import * as dateFormat from 'dateformat'
export default Vue.extend({

  data() {
    return {
      loading: false,
      errorMessage: '',
      startDate: dateFormat(new Date(Date.now() - (69 * 24 * 60 * 60 * 1000)), 'yyyy-mm-dd'),
      endDate: dateFormat(new Date(), 'yyyy-mm-dd'),
      batchIds: '',
      alps: '',
      advertiserNames: '',
      status: null,
      users: [],
      results: [],
      companyId: '',
      networkName: '',
    }
  },

  methods: {

    onUserInput(e) {
      this.users.push({
        userId: e.id,
        name: e.name,
      })
    },

    isValid() {

      // Max 90 day time range
      const ninetyDaysMs = 1000 * 60 * 60 * 24 * 90
      const start = new Date(this.startDate).getTime()
      const end = new Date(this.endDate).getTime()
      if (start > end || end - start > ninetyDaysMs) {
        this.errorMessage = 'Start date must be before end date and no greater than a 90 day time range'
        return false
      }

      return true
    },

    onCompanyInput(e){
      this.companyId = e
    },

    onNetworkInput(e){
      this.networkName = e
    },

    async generateCSV(type) {
      if (! this.isValid()) {
        return
      }

      this.loading = true
      const { data: { generateBatchCSVFromSearch } } = await this.$apollo.query({
        query: gql`
          query GenerateBatchCSVFromSearch(
            $type: String!,
            $batchIds: [ID!],
            $startDate: DateTime!,
            $endDate: DateTime!,
            $advertiserAlps: [String!],
            $advertiserNames: [String!],
            $status: String,
            $assigneeIds: [ID!],
            $results: [String!],
            $companyId: ID!,
            $networkName: String

          ) {
            generateBatchCSVFromSearch(
              type: $type
              batchIds: $batchIds
              startDate: $startDate
              endDate: $endDate
              advertiserAlps: $advertiserAlps
              advertiserNames: $advertiserNames
              status: $status
              assigneeIds: $assigneeIds
              results: $results
              companyId: $companyId
              networkName: $networkName
            )
          }
        `,
        variables: {
          type,
          batchIds: (this.batchIds) ? this.batchIds.split(',') : null,
          startDate: this.startDate,
          endDate: this.endDate,
          advertiserAlps: (this.alps) ? this.alps.split(',') : null,
          advertiserNames: (this.advertiserNames) ? this.advertiserNames.split(',') : null,
          status: this.status,
          assigneeIds: this.users.map(u => u.id),
          results: this.results,
          companyId: this.companyId,
          networkName: this.networkName
        }
      })

      // If no audits were found display error message
      if (! generateBatchCSVFromSearch || generateBatchCSVFromSearch === 'No audits matched the criteria') {
        this.errorMessage = 'No audits were found for the given search'
      }
      // Otherwise, generate CSV download
      else {
        this.$moonpull.downloadCsv(generateBatchCSVFromSearch, `batches_${this.startDate}_${this.endDate}.csv`)
      }

      this.loading = false
    }

  },
});
</script>